import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth, { IDToken } from "@okta/okta-auth-js";
import { ApiService } from "src/app/core/services/api.service";
import { ConfigurationService } from "src/app/core/services/configuration.service";
import { ToastService } from "src/app/core/services/toast.service";
import { LoadingComponent } from "src/app/utils/loading/loading.component";
import { UtilsService } from "src/app/utils/utils.service";


@Component({
    selector: 'app-login-redirect',
    templateUrl: './login-redirect.component.html',
    styleUrls: ['./login-redirect.component.scss'],
    standalone: true,
    imports: [
        LoadingComponent
    ]
})
export class LoginRedirectComponent implements OnInit {
    constructor(
        private readonly apiService: ApiService,
        private readonly router: Router,
        private readonly configurationService: ConfigurationService,
        private readonly toastService: ToastService,
        private readonly translateService: TranslateService,
        @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
        private readonly utilsService: UtilsService
    ) { }

    async ngOnInit() {
        try {
            const idToken = await this.oktaAuth.tokenManager.get('idToken') as IDToken;
            if(!idToken || !idToken.idToken) {
                await this.router.navigate(['/login']);
                this.toastService.showError('TOAST.ERROR', 'SIGNIN.BODY.INVALID_OKTA_TOKEN', true);
                return;
            }

            const errorCode = await this.apiService.get<string>(`users/signin?token=${idToken.idToken}`);
            if (errorCode !== '0000'){
                this.showErrorToast(errorCode);
                await this.router.navigate(['/login']);
                return;
            }

            await this.configurationService.setInitialConfgiguration();
            this.configurationService.setStyle();

            const defaultHome = await this.utilsService.getCurrentUserHomePath();
            await this.router.navigate([defaultHome]);
        } catch (error) {
            console.log(error);
            this.toastService.showError('TOAST.ERROR', 'COMMON.ERROR', true);
            await this.router.navigate(['/login']);
        }
    }

    private showErrorToast(errorCode: string): void {
        const header = this.getErrorHeader(errorCode);
        const body = this.translateService.instant(`SIGNIN.BODY.${errorCode}`);
        this.toastService.showError(header, body, false, 4500);
    }

    private getErrorHeader(errorCode: string): string {
        switch(errorCode){
            case '1024':
            case '1026':
            case '1293':
            case '1294':
            case '1295':
            case '1296':
            case '3999':
            case '5007':
            case '5008':
            case '5009':
                return this.translateService.instant('SIGNIN.HEADER.SECURITY', { errorCode });
            case '3020':
            case '3027':
            case '3305':
            case '3306':
            case '3307':
            case '3308':
            case '3309':
                return this.translateService.instant('SIGNIN.HEADER.ERROR', { errorCode });
            default:
                return this.translateService.instant('TOAST.ERROR');
        }
    }
}
